module.exports = __webpack_public_path__ + "img/it.c5125918.svg";